import type { Order } from '@src/orders/domain/Order';
import type { PermitApplication } from '@src/orders/domain/PermitApplication';
import {
  CommodityField,
  FloridaLoadDescriptionField,
  FloridaLoadIdentityField,
  FloridaPermitTypeField,
  LoadDescriptionField,
  LoadDispositionField,
  LoadEndToEndCountField,
  LoadHeightField,
  LoadIndustryTypeField,
  LoadIsNewlyManufacturedField,
  LoadIsSingleItemField,
  LoadLengthField,
  LoadLoadingMethod,
  LoadMakeField,
  LoadModelField,
  LoadOwnerAddressField,
  LoadOwnerNameField,
  LoadQuantityField,
  LoadSealedContainerChassisNumberField,
  LoadSealedContainerNumberField,
  LoadSerialNumberField,
  LoadSideBySideCountField,
  LoadStackCountField,
  LoadWeightField,
  LoadWidthField,
  LoadYearField,
} from '@src/permitField/LoadInformationFields';
import {
  IsUsedMobileHomeField,
  LoadIsMobileHomeField,
  MobileHomeBoxLengthField,
  MobileHomeBoxWidthField,
  MobileHomeCurbsideEavesLengthField,
  MobileHomeEaveWidthField,
  MobileHomeHitchLengthField,
  MobileHomeHudNumberField,
  MobileHomeMakeField,
  MobileHomeRoadsideEavesLengthField,
  MobileHomeSerialNumberField,
  MobileHomeYearField,
} from '@src/permitField/MobileHomeFields';
import { CategorySection } from '@src/permits/CategorySection';
import { useTranslation } from 'react-i18next';

export const LoadInformationCategory = ({
  permitApplication,
  order,
}: {
  permitApplication: PermitApplication;
  order: Order;
}) => {
  const { t } = useTranslation();
  const fields = permitApplication.getFieldsBySection('loadInformation');
  if (fields.size === 0) return null;

  return (
    <CategorySection
      title={t('orderSections.loadInformation')}
      requiredFields={Array.from(fields.values()).flat()}
      permitApplication={permitApplication}
      order={order}
      subsections={[
        {
          label: t('loadInformation'),
          fields: [
            LoadDescriptionField.fieldName,
            FloridaPermitTypeField.fieldName,
            FloridaLoadDescriptionField.fieldName,
            FloridaLoadIdentityField.fieldName,
            CommodityField.fieldName,
            LoadMakeField.fieldName,
            LoadModelField.fieldName,
            LoadSerialNumberField.fieldName,
            LoadIndustryTypeField.fieldName,
            LoadQuantityField.fieldName,
            LoadYearField.fieldName,
            LoadLoadingMethod.fieldName,
            LoadIsSingleItemField.fieldName,
            LoadDispositionField.fieldName,
            LoadSideBySideCountField.fieldName,
            LoadEndToEndCountField.fieldName,
            LoadStackCountField.fieldName,
            LoadIsNewlyManufacturedField.fieldName,
            LoadOwnerNameField.fieldName,
            LoadOwnerAddressField.fieldName,
            LoadLengthField.fieldName,
            LoadWidthField.fieldName,
            LoadHeightField.fieldName,
            LoadWeightField.fieldName,
            LoadSealedContainerNumberField.fieldName,
            LoadSealedContainerChassisNumberField.fieldName,
          ],
        },
        {
          label: t('mobileHome'),
          fields: [
            LoadIsMobileHomeField.fieldName,
            IsUsedMobileHomeField.fieldName,
            MobileHomeYearField.fieldName,
            MobileHomeMakeField.fieldName,
            MobileHomeSerialNumberField.fieldName,
            MobileHomeHitchLengthField.fieldName,
            MobileHomeEaveWidthField.fieldName,
            MobileHomeBoxWidthField.fieldName,
            MobileHomeBoxLengthField.fieldName,
            MobileHomeRoadsideEavesLengthField.fieldName,
            MobileHomeCurbsideEavesLengthField.fieldName,
            MobileHomeHudNumberField.fieldName,
          ],
        },
      ]}
    />
  );
};
